import { useEffect, useState } from "react";

interface UseTypingEffectProps {
  text: string;
  speed?: number;
  isVisible: boolean;
}

export const useTypingEffect = ({
  text,
  speed = 50,
  isVisible,
}: UseTypingEffectProps) => {
  const [displayedText, setDisplayedText] = useState("");
  const [hasTyped, setHasTyped] = useState(false);

  useEffect(() => {
    if (!isVisible || hasTyped) return;

    setHasTyped(true);
    let currentIndex = 0;

    const interval = setInterval(() => {
      if (currentIndex <= text.length) {
        setDisplayedText(text.slice(0, currentIndex));
        currentIndex++;
      } else {
        clearInterval(interval);
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, isVisible, hasTyped]);

  return displayedText;
};
